<template>

  <div class="rows">

    <div class="row" v-for="tournee in tournees.data" v-bind:key="tournee.id">
      <div class="col-xs-5">
        <span class="title-item">Date de début</span>
        <span class="text-item">{{formatDate(tournee.startedAt)}}</span>
      </div>
      <!--<div class="col-xs-5">
        <span class="title-item">Date de fin</span>
        <span class="text-item">
          {{ formatDate(tournee.endedAt) }}
        </span>
      </div>-->
      <div class="col-xs-5">
              <span class="title-item">Status</span>
              <span class="text-item">
                {{ tournee.statusTournee }}
              </span>
            </div>
            <div class="col-xs-5">
                    <span class="title-item">Maitrise</span>
                    <span class="text-item">
                      {{ tournee.maitriseNom }}
                    </span>
                  </div>
                  <div class="col-xs-5">
                                      <span class="title-item">Cantonnier</span>
                                      <span class="text-item">
                                        {{ tournee.cantonnierNom }}
                                      </span>
                                    </div>
      <div class="col-xs-5">
              <span class="title-item">Nombre de remontée</span>
              <span class="text-item">
                {{ tournee.nbRemonteesGps }}
              </span>

            </div>
      <div class="col-xs-5">
        <span class="title-item">Date de la dernière remontée</span>
        <span class="text-item">
          {{ formatDate(tournee.dateLastRemontee) }}
        </span>

      </div>
      <div class="col-xs-2">
        <div class="actions">
          <a class="action-close" v-on:click="$emit('close', tournee)">
            <img src="../../../../static/img/delete-icon-def.svg" alt="Fermer">
          </a>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import { mapState } from 'vuex'
import _ from 'lodash'

export default {
  computed: {
    ...mapState([
      'tournees'
    ]),
  },
  mounted: function () {
    this.$store.dispatch('fetchTourneesByVilleId')
  },
  methods: {
    formatDate(date) {
      if (!date) return '—';
      const d = new Date(date);
      return d.toLocaleString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    }
  }

}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// TourneesList.vue?f5374318